import axios from "./axiosInstance";
import {
  ExpenseCategoryApiResponse,
  ExpenseCategoryDetailsApiResponse,
  ExpenseCategoryCreatePayload,
  ExpenseCategoryUpdatePayload,
  ExpenseCategorySearchParams,
  PaginatedExpenseCategoryApiResponse
} from "../types/expenseCategoryTypes";

/**
 * Create a new expense category
 */
export const createExpenseCategory = async (payload: ExpenseCategoryCreatePayload): Promise<ExpenseCategoryApiResponse> => {
  const response = await axios.post<ExpenseCategoryApiResponse>("/expense-categories", payload);
  return response.data;
};

/**
 * Search expense categories with optional parameters
 */
export const searchExpenseCategories = async (params: ExpenseCategorySearchParams): Promise<PaginatedExpenseCategoryApiResponse> => {
  const response = await axios.get<PaginatedExpenseCategoryApiResponse>("/expense-categories/search", { params });
  return response.data;
};

/**
 * Fetch all expense categories
 */
export const getAllExpenseCategories = async (filters: { [key: string]: string | number | null } = {}): Promise<PaginatedExpenseCategoryApiResponse> => {
  const response = await axios.get<PaginatedExpenseCategoryApiResponse>("/expense-categories", { params: { ...filters , page: 1, limit: 10000 } });
  return response.data;
};

/**
 * Fetch a specific expense category by ID
 */
export const getExpenseCategoryById = async (categoryId: string): Promise<ExpenseCategoryDetailsApiResponse> => {
  const response = await axios.get<ExpenseCategoryDetailsApiResponse>(`/expense-categories/${categoryId}`);
  return response.data;
};

/**
 * Update an existing expense category
 */
export const updateExpenseCategory = async (categoryId: string, payload: ExpenseCategoryUpdatePayload): Promise<ExpenseCategoryApiResponse> => {
  const response = await axios.put<ExpenseCategoryApiResponse>(`/expense-categories/${categoryId}`, payload);
  return response.data;
};

/**
 * Delete an expense category
 */
export const deleteExpenseCategory = async (categoryId: string): Promise<ExpenseCategoryApiResponse> => {
  const response = await axios.delete<ExpenseCategoryApiResponse>(`/expense-categories/${categoryId}`);
  return response.data;
};